/* ============
 * All Cities
 * ============
 *
 * All cities from a country.
 */

import Vue from 'vue';
import store from './../../store';
import exciseGroupTransformer from './../../transformers/exciseGroup';

const success = ({ data }, resolve) => {
  const exciseGroups = exciseGroupTransformer.fetchCollection(data.data);
  store.dispatch('fetchExciseGroup', { exciseGroups });
  // store.dispatch('setNullOnExciseGroup');
  resolve();
};

const failed = () => {
};

// Display cities related to a country.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('groups')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/exciseGroup/all.js